<template>
  <ul class="clearfix tabs" :class="{ 'tabs-new': isNew }">
    <li
      class="tab-item"
      :class="current == item[idKey] ? 'tab-item-current ' + currentClass : ''"
      @click="changeTab(item)"
      :key="item[idKey]"
      v-for="item in items"
    >
      <slot name="header" :item="item">
        <span :title="item[nameKey]">{{ item[nameKey] }}</span>
      </slot>
      <div class="tab-line"></div>
    </li>
  </ul>
</template>
<script>
export default {
  name: "BlockTabs",
  props: {
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
    idKey: {
      type: String,
      default: "id",
    },
    nameKey: {
      type: String,
      default: "name",
    },
    currentClass: {
      type: String,
      default: "",
    },
    value: {},
    isNew: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: "",
    };
  },
  created() {
    this.current = this.value;
    this.initCurrent();
  },
  methods: {
    changeTab(item) {
      this.current = item[this.idKey];
      this.$emit("changeTab", item);
    },
    initCurrent() {
      if (this.items.length == 0) {
        return;
      }
      if (
        this.current &&
        this.items.filter(item => item[this.idKey] == this.current).length > 0
      ) {
        return;
      }
      this.current = this.items[0][this.idKey];
    },
  },
  watch: {
    items() {
      this.initCurrent();
    },
    value() {
      this.initCurrent();
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs {
  background-color: #f8f8f8;
}

.tab-item {
  float: left;
  width: 165px;
  height: 53px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(183, 183, 183, 1);
  text-align: center;
  cursor: pointer;
  position: relative;

  span {
    display: block;
    border-left: 1px solid #d9d9d9;
    margin-top: 16px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:first-child {
    span {
      border-left: none;
    }
  }

  &:last-child span {
    border-right: none;
  }

  .tab-line {
    position: absolute;
    bottom: 0;
    left: 68px;
    width: 28px;
    height: 3px;
    border-radius: 2px;
    background-color: $primary-color;
    display: none;
  }

  &.tab-item-current {
    background-color: white;
    color: $primary-color;

    span {
      border-left: none;
      border-right: none;
    }

    .tab-line {
      display: block;
    }
  }

  &.tab-item-current + .tab-item {
    span {
      border-left: none;
    }
  }
}

.tabs-new {
  background-color: #fff !important;

  .tab-line {
    display: none !important;
  }

  .tab-item {
    width: 154px;
    margin-right: 40px;
    font-size: 18px !important;
    color: #999999 !important;
    font-weight: 400;

    span {
      display: inline-block;
      border: none;
      position: relative;
      padding: 0 4px;
    }
  }

  .tab-item-current {
    font-size: 18px !important;
    color: #333 !important;

    span {
      z-index: 0;
      &::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 6px;
        background: linear-gradient(
          90deg,
          $primary-color-8,
          $primary-color
        ) !important;
        bottom: 1px;
        left: 0;
        opacity: 0.8;
        z-index: -1;
      }
    }
  }
}
</style>
